export default __webpack_public_path__ + "static/media/ttaCertifiedBadge.37bd0b15.svg";